import { em, math } from 'polished'
import styled, { css } from 'styled-components'

import TextWithCheck from 'components/_special/TextWithCheck'
import DiscountLabel from 'components/DiscountLabel'
import { TextLH, TextMedium } from 'styles/components/typography'

export const Layout = styled.div`
  ${p => p.theme.mq.upMd} {
    min-height: ${p =>
      math(
        `${p.theme.typography.textMedium} * ${p.theme.typography.textMediumLh} * 2`,
      )};
  }
`

export const LayoutWrapper = styled.div`
  position: relative;
  padding-top: ${em(20)};
  padding-bottom: ${em(20)};

  ${p => p.theme.mq.upMd} {
    padding-top: ${em(40)};
    padding-bottom: ${em(40)};
  }

  ${p => p.theme.mq.upLg} {
    position: static;
    display: flex;
    align-items: center;
  }
`

export const TitleBlock = styled.div`
  position: relative !important;

  ${p => p.theme.mq.upMd} {
    position: static !important;
  }

  ${p => p.theme.mq.upLg} {
    position: relative !important;
  }

  ${({ centered, isEmpty }) =>
    centered &&
    css`
      ${isEmpty &&
        css`
          display: flex;
          align-items: center;
        `}

      ${p => p.theme.mq.upMd} {
        display: flex;
        align-items: center;
      }
    `}
`

export const Title = styled.div`
  max-width: ${em(270)};
`

export const Label = styled.div`
  display: none;
  align-items: center;
  margin-bottom: ${p => em(7, p.theme.typography.fontSizeBasePx)};

  ${p => p.theme.mq.upMd} {
    display: flex;
    font-family: ${p => p.theme.typography.mediumFont};
    // margin-bottom: 0;
  }
`

export const DiscountLabelStyled = styled(DiscountLabel)`
  display: inline;
  line-height: 2.9;
  font-size: ${p => p.theme.typography.textSmallForms};
  margin-left: ${em(10)};
  padding-left: ${em(4)};
  padding-right: ${em(4)};
  padding-bottom: ${em(2)};
  top: -${em(3)};

  ${p => p.theme.mq.upMd} {
    display: none;
  }
`

export const TextLHStyled = styled(TextLH)`
  margin-right: ${p => em(10, p.theme.typography.fontSizeBasePx)};

  ${p => p.theme.mq.upMd} {
    font-family: ${p => p.theme.typography.mediumFont};
  }
`

export const TextMediumStyled = styled(TextMedium)`
  ${({ isSpecial }) =>
    isSpecial &&
    css`
      font-family: ${p => p.theme.typography.mediumFont};

      ${p => p.theme.mq.upMd} {
        font-family: ${p => p.theme.typography.baseFont};
      }
    `}
`

export const Subtitle = styled.div`
  margin-top: ${em(7)};
`

export const TextWithCheckStyled = styled(TextWithCheck)`
  margin-left: 0;
  padding-top: ${em(5)};
  padding-bottom: 0;
  padding-left: 0;
  line-height: 1.4;

  ${p => p.theme.mq.upMd} {
    padding-top: ${em(5)};
  }
`

export const LayoutBlock = styled.div`
  ${({ centered }) =>
    centered &&
    css`
      ${p => p.theme.mq.upLg} {
        display: flex;
        align-items: center;
      }
    `}

  ${({ isWideOnMobile }) =>
    isWideOnMobile &&
    css`
      ${p => p.theme.mq.downMd} {
        flex-basis: 100%;
        max-width: 100%;
      }
    `}
`
